const postQuestions = {
  toastrTrue: 'Added group',
  toastrFalse: 'Question added',
  txt: 'has been updated successfully'
};

export default postQuestions;
